export default [
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "RegisterPage" */ './pages/RegisterPage.vue'),
    meta: {
      title: '用户注册',
      auth: false,
    },
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "LoginPage" */ './pages/LoginPage.vue'),
    meta: {
      title: '用户登录',
      auth: false,
    },
  },
  {
    path: '',
    component: DefaultLayout,
    children: [
      {
        path: '',
        redirect: '/home',
      },
      {
        path: '/modify-password',
        component: () => import(/* webpackChunkName: "ModifyPassword" */ './pages/ModifyPassword'),
        meta: {
          title: '修改密码',
        },
      },
    ],
  },
]
